import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/createCode",
    name: "createCode",
    component: dashboard,
    redirect: {
      name: "createCodeIndex"
    },
    children: [
      {
        path: "createCodeIndex",
        name: "createCodeIndex",
        meta: { title: "已售产品码管理" },
        component: () => import("@/views/createCode/createCodeRecord.vue"),
        children: [
          {
            path: "editCreateCodeInfo/:createCodeRecordId",
            name: "editCreateCodeInfo",
            meta: { title: "已售产品码信息维护" },
            component: () => import("@/views/createCode/createCodeManage.vue")
          },
          {
            path: "addCreateCodeInfo",
            name: "addCreateCodeInfo",
            meta: { title: "已售产品码添加" },
            component: () => import("@/views/createCode/addCreateCode.vue")
          }
        ]
      },
      {
        path: "newQrCode",
        name: "newQrCode",
        meta: { title: "新建二维码" },
        component: () => import("@/views/newQrCode/index.vue"),
        children: []
      }
    ]
  }
];
